export class ConsultationType {
    static OPEN = 'open';
    static REVIEW = 'review';
    static CLOSED = 'closed';
    static CANCELED = 'canceled';
}